import Joi from 'joi'
import AbstractModel from './AbstractModel'
import ClientModel from './ClientModel'

export default class AuthContext extends AbstractModel {
  constructor (data) {
    super(data)
    Object.freeze(this)
  }

  static get schema () {
    return {
      client: Joi.object().instance(ClientModel).required(),
      redirectUrl: Joi.string().required(),
      state: Joi.string().allow(null, ''),
      refcode: Joi.string().allow(null, ''),
      codeChallenge: Joi.string().allow(null, '')
    }
  }

  static fromJs (data) {
    return new AuthContext(data, { stripUnknown: true })
  }
}
